const pageNameKey = "transferConfigurationToClientButton";

export const transferConfigurationToClientButtonEn = {
  [pageNameKey]: {
    saveStructureButtonText: "Transfer Configuration to Client",
  },
};

export const transferConfigurationToClientButtonPtBr = {
  [pageNameKey]: {
    saveStructureButtonText: "Transferir configuração para o cliente",
  },
};

export const transferConfigurationToClientButtonDe = {
  [pageNameKey]: {
    saveStructureButtonText: "Konfiguration an Client übertragen",
  },
};

export const transferConfigurationToClientButtonZhHans = {
  [pageNameKey]: {
    saveStructureButtonText: "将配置传输到客户端",
  },
};

export const transferConfigurationToClientButtonIt = {
  [pageNameKey]: {
    saveStructureButtonText: "Trasferisci Configurazione al client",
  },
};

export const transferConfigurationToClientButtonEs = {
  [pageNameKey]: {
    saveStructureButtonText: "Transferir configuración al cliente",
  },
};

export const transferConfigurationToClientButtonNl = {
  [pageNameKey]: {
    saveStructureButtonText: "Configuratie naar client overdragen",
  },
};

export const transferConfigurationToClientButtonTr = {
  [pageNameKey]: {
    saveStructureButtonText: "Yapılandırmayı İstemciye Aktarın",
  },
};
